import { z } from 'zod'

import { MinimumFile } from '@/modules/shared/schemas/MinimumFile'
import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'
import { Time } from '@/shared/types/time/time'

export const StatusEnum = z.enum(['ACTIVE', 'EXPIRED', 'INACTIVE'])

export const TypeMedicine = z.enum([
  'DROPS',
  'PILLS',
  'ML',
  'G',
  'MG',
  'ENVELOPE'
])

export const MedicationAdministration = z.enum([
  'ORAL',
  'SUBLINGUAL',
  'RECTAL',
  'OCULAR',
  'TOPIC',
  'INTRAVENOUS',
  'INTRADERMAL',
  'INTRAMUSCULAR',
  'SUBCUTANEOUS',
  'NOSE',
  'AURICULAR'
])

export const PrescriptionInterval = z.enum([
  'DAILY',
  'DAY_INTERVAL',
  'WEEKLY',
  'MONTHLY'
])

export const TypeSchedule = z.enum(['SCHEDULE', 'PUNCTUAL'])

export const DayOfWeek = z.enum([
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
])

export const GroupRemedyResponse = z.object({
  id: z.string(),
  name: z.string()
})

export const RemedyResponse = z.object({
  id: z.string(),
  name: z.string(),
  typeMedicine: TypeMedicine,
  medicationAdministration: MedicationAdministration,
  groupRemedy: GroupRemedyResponse
})

export const RemedyPrescriptionResponse = z.object({
  id: z.string(),
  remedy: RemedyResponse,
  dosage: z.number(),
  prescriptionInterval: PrescriptionInterval,
  typeSchedule: TypeSchedule,
  time: Time,
  dayOfWeeks: z.array(DayOfWeek),
  observation: z.string(),
  dayRange: z.number().int(),
  initialDate: z.string().date(),
  applicationLocation: z.string()
})

export const FullPrescriptionPaient = z.object({
  id: z.string(),
  status: StatusEnum,
  initialDate: z.string().date(),
  endDate: z.string().date(),
  patientId: z.string(),
  responsible: PersonaInfoSummary,
  files: z.array(MinimumFile),
  remedyPrescriptions: z.array(RemedyPrescriptionResponse)
})

export type FullPrescriptionPaient = z.infer<typeof FullPrescriptionPaient>
